export default {
  noInsuranceDoc: {
    anyValues: {
      issues: [
        {
          id: 'I-DEM-INS-1000',
          domain: 'DDEM'
        }
      ],
      triggerValue: true
    }
  },
  understandCoverage: {
    issues: [
      {
        id: 'I-DEM-INS-1700',
        domain: 'DBDC',
        isDynamic: true,
        dynamicParameters: { carrier: 'provider' }
      }
    ],
    triggerValue: 'no'
  },
  understandCopay: {
    issues: [
      {
        id: 'I-DEM-INS-1800',
        domain: 'DBDC',
        isDynamic: true,
        dynamicParameters: { carrier: 'provider' }
      }
    ],
    triggerValue: 'no'
  },
  understandProvider: {
    issues: [
      {
        id: 'I-DEM-INS-1900',
        domain: 'DBDC',
        isDynamic: true,
        dynamicParameters: { carrier: 'provider' }
      }
    ],
    triggerValue: 'no'
  },
  understandBalance: {
    issues: [
      {
        id: 'I-DEM-INS-2000',
        domain: 'DBDC',
        isDynamic: true,
        dynamicParameters: { carrier: 'provider' }
      }
    ],
    triggerValue: 'no'
  }
}
